import styled from 'styled-components';
import { brand } from 'styles/Colors';

export const SelectWrapper = styled.div`
  .MuiInputLabel-root.Mui-focused {
    color: ${brand};
  }

  &&& {
    :focus,
    :active {
      outline: none;
    }

    .MuiInputBase-root::after {
      border-bottom: 4px solid #ec691a;
    }
  }
`;
